import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Routes } from "../routes";
import { useDispatch, useSelector } from "react-redux";
// pages
import Presentation from "./Presentation";
import Upgrade from "./Upgrade";
import DashboardOverview from "./dashboard/DashboardOverview";
import Transactions from "./Transactions";
import Settings from "./Settings";
import BootstrapTables from "./tables/BootstrapTables";
import Signin from "./examples/Signin";
import Signup from "./examples/Signup";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import Lock from "./examples/Lock";
import NotFoundPage from "./examples/NotFound";
import ServerError from "./examples/ServerError";

// documentation pages
import DocsOverview from "./documentation/DocsOverview";
import DocsDownload from "./documentation/DocsDownload";
import DocsQuickStart from "./documentation/DocsQuickStart";
import DocsLicense from "./documentation/DocsLicense";
import DocsFolderStructure from "./documentation/DocsFolderStructure";
import DocsBuild from "./documentation/DocsBuild";
import DocsChangelog from "./documentation/DocsChangelog";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";

import Accordion from "./components/Accordion";
import Alerts from "./components/Alerts";
import Badges from "./components/Badges";
import Breadcrumbs from "./components/Breadcrumbs";
import Buttons from "./components/Buttons";
import Forms from "./components/Forms";
import Modals from "./components/Modals";
import Navs from "./components/Navs";
import Navbars from "./components/Navbars";
import Pagination from "./components/Pagination";
import Popovers from "./components/Popovers";
import Progress from "./components/Progress";
import Tables from "./components/Tables";
import Tabs from "./components/Tabs";
import Tooltips from "./components/Tooltips";
import Toasts from "./components/Toasts";
import ViewCollector from "./Collectors/ViewCollector";
import AddCollector from "./Collectors/AddCollector";
import CollectorDetail from "./Collectors/CollectorDetail";
import ViewCustomer from "./Customers/ViewCustomer";
import AddCustomer from "./Customers/AddCustomer";
import CustomerDetail from "./Customers/CustomerDetail";
import ViewSahakari from "./Sahakari/ViewSahakari";
import AddSahakari from "./Sahakari/AddSahakari";
import SahakariDetails from "./Sahakari/SahakariDetails";
import { getCookie, isAuth } from "../helpers/authHelper";
import { getUser, setInitialLoading } from "../redux/actions/auth";
import Profile from "./Profile/Profile";
import { getSahakari, getSahakariSubStatus } from "../redux/actions/sahakari";
import EditCustomer from "./Customers/EditCustomer";
import EditCollector from "./Collectors/EditCollector";
import EditSahakari from "./Sahakari/EditSahakari";
import CustomerTransactionDetail from "./Customers/CustomerTransactionDetail";
import ViewBatch from "./Batch/ViewBatch";
import ViewBatchTransaction from "./Batch/ViewBatchTransaction";
import ViewBatchDate from "./Batch/ViewBatchDate";
import BatchAssignCustomer from "./Customers/BatchAssignCustomer";
import UnassignedCustomers from "./Notifications/UnassignedCustomers";
import WithdrawlRequests from "./Notifications/WithdrawlRequests";
// import SelectTransactionDate from "./Transactions/SelectTransactionDate";
import ViewTransactions from "./Transactions/ViewTransactions";
import TransactionViewBatch from "./Transactions/TransactionViewBatch";
import ViewTransactionsByBatchId from "./Transactions/ViewTransactionsByBatchId";
import AddSahakariCustomers from "./Sahakari/AddSahakariCustomers";
import PendingBatches from "./Notifications/PendingBatches";
import InitBatches from "./Notifications/InitBatches";

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          {" "}
          <Preloader show={loaded ? false : true} /> <Component {...props} />{" "}
        </>
      )}
    />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const { initialLoading, userData } = useSelector((state) => state.user);

  return (
    <>
      {initialLoading === true ? (
        <Preloader show={true} />
      ) : (
        <Route
          {...rest}
          render={(props) =>
            userData != null && userData.role !== "ROLE_COLLECTOR" ? (
              <>
                {/* <Preloader show={loaded ? false : true} /> */}
                <Sidebar />

                <main className="content">
                  <Navbar />
                  <Component {...props} />
                  {/* <Footer
toggleSettings={toggleSettings}
showSettings={showSettings}
/> */}
                </main>
              </>
            ) : (
              <Redirect to="/" />
            )
          }
        />
      )}
    </>
  );
};
const SahakariRoute = ({ component: Component, ...rest }) => {
  const { initialLoading, userData } = useSelector((state) => state.user);

  return (
    <>
      {initialLoading === true ? (
        <Preloader show={true} />
      ) : (
        <Route
          {...rest}
          render={(props) =>
            userData != null && userData.role === "ROLE_ADMIN" ? (
              <>
                <Sidebar />

                <main className="content">
                  <Navbar />
                  <Component {...props} />
                </main>
              </>
            ) : (
              <Redirect to="/" />
            )
          }
        />
      )}
    </>
  );
};
const SuperAdminRoute = ({ component: Component, ...rest }) => {
  const { initialLoading, userData } = useSelector((state) => state.user);

  return (
    <>
      {initialLoading === true ? (
        <Preloader show={true} />
      ) : (
        <Route
          {...rest}
          render={(props) =>
            userData?.role === "ROLE_SUPERADMIN" ? (
              <>
                <Sidebar />

                <main className="content">
                  <Navbar />
                  <Component {...props} />
                </main>
              </>
            ) : (
              <Redirect to="/" />
            )
          }
        />
      )}
    </>
  );
};

export default () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { accessToken, userData } = useSelector((state) => state.user);

  useEffect(() => {
    if (accessToken !== "" && userData?.role === "ROLE_ADMIN") {
      //dispatch call to api here
      dispatch(getSahakariSubStatus());
    }
  }, [accessToken, userData]);

  useEffect(() => {
    setLoading(true);
    if (isAuth()) {
      const refreshToken = getCookie("refreshToken");

      dispatch(getUser(refreshToken)).then(() => setLoading(false));
    } else {
      setLoading(false);
    }
    dispatch(setInitialLoading(false));
  }, []);
  return (
    <>
      {loading ? (
        <Preloader show={true} />
      ) : (
        <Switch>
          <Route exact path={Routes.Presentation.path} component={Signin} />
          {/* <RouteWithLoader exact path={Routes.Signin.path} component={Signin} /> */}
          <Route exact path={Routes.Signin.path} component={Signin} />
          {/* <RouteWithLoader exact path={Routes.Signup.path} component={Signup} /> */}
          {/* <RouteWithLoader exact path={Routes.Presentation.path} component={Signin} /> */}

          <RouteWithLoader
            exact
            path={Routes.test.path}
            component={Presentation}
          />

          <RouteWithLoader
            exact
            path={Routes.NotFound.path}
            component={NotFoundPage}
          />
          <RouteWithLoader
            exact
            path={Routes.ServerError.path}
            component={ServerError}
          />

          {/* pages */}
          <RouteWithSidebar
            exact
            path={Routes.DashboardOverview.path}
            component={DashboardOverview}
          />
          <RouteWithSidebar
            exact
            path={Routes.Upgrade.path}
            component={Upgrade}
          />
          <RouteWithSidebar
            exact
            path={Routes.Transactions.path}
            component={Transactions}
          />
          <RouteWithSidebar
            exact
            path={Routes.Settings.path}
            component={Settings}
          />
          <RouteWithSidebar
            exact
            path={Routes.BootstrapTables.path}
            component={BootstrapTables}
          />

          <RouteWithSidebar
            exact
            path={Routes.Profile.path}
            component={Profile}
          />

          {/* customers */}
          <SuperAdminRoute
            exact
            path={Routes.ViewSahakari.path}
            component={ViewSahakari}
          />
          <SuperAdminRoute
            exact
            path={Routes.AddSahakari.path}
            component={AddSahakari}
          />
          <SuperAdminRoute
            exact
            path={Routes.SahakariDetails.path}
            component={SahakariDetails}
          />
          <SuperAdminRoute
            exact
            path={Routes.SahakariEdit.path}
            component={EditSahakari}
          />
          <SuperAdminRoute
            exact
            path={Routes.AddSahakariCustomers.path}
            component={AddSahakariCustomers}
          />

          {/* Collectors */}
          <SahakariRoute
            exact
            path={Routes.ViewCollectors.path}
            component={ViewCollector}
          />
          <SahakariRoute
            exact
            path={Routes.AddCollectors.path}
            component={AddCollector}
          />
          <SahakariRoute
            exact
            path={Routes.CollectorsDetail.path}
            component={CollectorDetail}
          />
          <SahakariRoute
            exact
            path={Routes.EditCollectors.path}
            component={EditCollector}
          />

          {/* customers */}
          <SahakariRoute
            exact
            path={Routes.ViewCustomers.path}
            component={ViewCustomer}
          />
          <SahakariRoute
            exact
            path={Routes.AssignCustomersBatch.path}
            component={BatchAssignCustomer}
          />
          <SahakariRoute
            exact
            path={Routes.AddCustomers.path}
            component={AddCustomer}
          />
          {/* <SahakariRoute
            exact
            path={Routes.AddCustomers2.path}
            component={AddCustomer2}
          /> */}
          <SahakariRoute
            exact
            path={Routes.CustomerDetail.path}
            component={CustomerDetail}
          />
          <SahakariRoute
            exact
            path={Routes.CustomerProfileTransactionActive.path}
            component={CustomerDetail}
          />
          <SahakariRoute
            exact
            path={Routes.CustomerEdit.path}
            component={EditCustomer}
          />
          <SahakariRoute
            exact
            path={Routes.CustomerTransactionDetail.path}
            component={CustomerTransactionDetail}
          />

          {/* Batch */}
          {/* <SahakariRoute
            exact
            path={Routes.ViewBatch.path}
            component={ViewBatch}
          />
          <SahakariRoute
            exact
            path={Routes.ViewBatchDate.path}
            component={ViewBatchDate}
          />
          <SahakariRoute
            exact
            path={Routes.ViewBatchTransaction.path}
            component={ViewBatchTransaction}
          /> */}
          <SahakariRoute
            exact
            path={Routes.ViewUnassignedCustomers.path}
            component={UnassignedCustomers}
          />
          <SahakariRoute
            exact
            path={Routes.ViewWithdrwalRequests.path}
            component={WithdrawlRequests}
          />
          <SahakariRoute
            exact
            path={Routes.ViewPendingBatches.path}
            component={PendingBatches}
          />
          <SahakariRoute
            exact
            path={Routes.ViewInitBatches.path}
            component={InitBatches}
          />
          {/* <SahakariRoute
            exact
            path={Routes.SelectTransactionDate.path}
            component={SelectTransactionDate}
          /> */}
          <SahakariRoute
            exact
            path={Routes.ViewTransactions.path}
            component={ViewTransactions}
          />
          <SahakariRoute
            exact
            path={Routes.ViewTodaysTransaction.path}
            component={ViewTransactions}
          />
          <SahakariRoute
            exact
            path={Routes.TransactionViewBatch.path}
            component={TransactionViewBatch}
          />
          <SahakariRoute
            exact
            path={Routes.ViewTransactionsByBatchId.path}
            component={ViewTransactionsByBatchId}
          />
          <SahakariRoute
            exact
            path={Routes.ViewTodaysBatches.path}
            component={TransactionViewBatch}
          />

          {/* components */}
          {/* <RouteWithSidebar
            exact
            path={Routes.Accordions.path}
            component={Accordion}
          />
          <RouteWithSidebar
            exact
            path={Routes.Alerts.path}
            component={Alerts}
          />
          <RouteWithSidebar
            exact
            path={Routes.Badges.path}
            component={Badges}
          />
          <RouteWithSidebar
            exact
            path={Routes.Breadcrumbs.path}
            component={Breadcrumbs}
          />
          <RouteWithSidebar
            exact
            path={Routes.Buttons.path}
            component={Buttons}
          />
          <RouteWithSidebar exact path={Routes.Forms.path} component={Forms} />
          <RouteWithSidebar
            exact
            path={Routes.Modals.path}
            component={Modals}
          />
          <RouteWithSidebar exact path={Routes.Navs.path} component={Navs} />
          <RouteWithSidebar
            exact
            path={Routes.Navbars.path}
            component={Navbars}
          />
          <RouteWithSidebar
            exact
            path={Routes.Pagination.path}
            component={Pagination}
          />
          <RouteWithSidebar
            exact
            path={Routes.Popovers.path}
            component={Popovers}
          />
          <RouteWithSidebar
            exact
            path={Routes.Progress.path}
            component={Progress}
          />
          <RouteWithSidebar
            exact
            path={Routes.Tables.path}
            component={Tables}
          />
          <RouteWithSidebar exact path={Routes.Tabs.path} component={Tabs} />
          <RouteWithSidebar
            exact
            path={Routes.Tooltips.path}
            component={Tooltips}
          />
          <RouteWithSidebar
            exact
            path={Routes.Toasts.path}
            component={Toasts}
          />

          <RouteWithSidebar
            exact
            path={Routes.DocsOverview.path}
            component={DocsOverview}
          />
          <RouteWithSidebar
            exact
            path={Routes.DocsDownload.path}
            component={DocsDownload}
          />
          <RouteWithSidebar
            exact
            path={Routes.DocsQuickStart.path}
            component={DocsQuickStart}
          />
          <RouteWithSidebar
            exact
            path={Routes.DocsLicense.path}
            component={DocsLicense}
          />
          <RouteWithSidebar
            exact
            path={Routes.DocsFolderStructure.path}
            component={DocsFolderStructure}
          />
          <RouteWithSidebar
            exact
            path={Routes.DocsBuild.path}
            component={DocsBuild}
          />
          <RouteWithSidebar
            exact
            path={Routes.DocsChangelog.path}
            component={DocsChangelog}
          /> */}

          {/* <RouteWithLoader
      exact
      path={Routes.ForgotPassword.path}
      component={ForgotPassword}
    /> */}
          {/* <RouteWithLoader
      exact
      path={Routes.ResetPassword.path}
      component={ResetPassword}
    /> */}
          {/* <RouteWithLoader exact path={Routes.Lock.path} component={Lock} /> */}
          <RouteWithSidebar exact path={Routes.Tabs.path} component={Badges} />
          {/* <RouteWithSidebar
            exact
            path={Routes.Tables.path}
            component={Tables}
          /> */}

          <Redirect to={Routes.NotFound.path} />
        </Switch>
      )}
    </>
  );
};
